export enum InvoicePeriod {
    ONETIME = 0,
    DAILY = 1,
    MONTHLY = 2,
    QUARTALY = 3,
    SEMIANNUALLY = 4,
    ANNULALY = 5
}
